require("../../node_modules/chosen-js/chosen.jquery.js");

module.exports = {
  init: () => {
    const $ = window.jQuery;

    chosenBrowserIsSupported = function() {
      if (/iP(od|ad|hone)/i.test(window.navigator.userAgent)) {
        return false;
      }
      if (/Android/i.test(window.navigator.userAgent)) {
        if (/Mobile/i.test(window.navigator.userAgent)) {
          return false;
        }
      }
      if (/IEMobile/i.test(window.navigator.userAgent)) {
        return false;
      }
      if (/Windows Phone/i.test(window.navigator.userAgent)) {
        return false;
      }
      if (/BlackBerry/i.test(window.navigator.userAgent)) {
        return false;
      }
      if (/BB10/i.test(window.navigator.userAgent)) {
        return false;
      }
      if (window.navigator.appName === "Microsoft Internet Explorer") {
        return document.documentMode >= 8;
      }
      return true;
    };

    if (chosenBrowserIsSupported()) {
      $(".chosen-select").chosen({ disable_search: true, width: "100%", inherit_select_classes: true });

      $(".chosen-select-multi").on("chosen:ready", function(event, data) {
        $(this)
          .closest(".chosen-wrapper")
          .find(".chosen-button")
          .show();
      });
      $(".chosen-publication").on("change", function(evt, params) {
        if (params.selected) {
          var elem = $(this).find('option[value="' + params.selected + '"]');
          if (elem) {
            elem.remove();
            $(this).append(elem);
            $(this).trigger("chosen:updated");
          }
        }
      });
      $(".chosen-wrapper").on("keyup", "input", function() {
        var element = $(this);
        element.parents(".chosen-wrapper").data("text", element.val());
      });
      $(".chosen-select-multi").chosen({ width: "100%", search_contains: true, no_results_text: "Ingen resultater for", inherit_select_classes: true });
      var globalInputContent = "";
      $(".chosen-button")
        .add(".chosen-button:before")
        .on("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          var placeholder = $(this)
            .siblings("select")
            .data("placeholder");
          var chosenWrapper = $(this).parents(".chosen-wrapper");
          var inputContent = chosenWrapper.data("text");
          if (inputContent === "") {
            inputContent = globalInputContent;
          }
          if (inputContent && inputContent !== placeholder) {
            var chosenElement = $(this)
              .closest(".chosen-wrapper")
              .find("select");
            chosenElement.append('<option value="' + inputContent + '" selected="selected">' + inputContent + "</option>");
            chosenElement.trigger("chosen:updated");
            globalInputContent = "";
          }
        });
      $(".chosen-wrapper .chosen-container .chosen-choices .search-field input").on("blur", function(e) {
        globalInputContent = $(this).val();
      });
    } else {
      $("select.chosen-select, select.chosen-select-multi").each(function() {
        var placeholder = $(this).data("placeholder");
        var option = $(this)
          .find("option")
          .first();
        option.val(0);
        option.text(placeholder);
        option.attr("disabled", true);
      });
    }
  },
};
